"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
var ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
function ColorToggleButton(_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, value = _a.value, onChange = _a.onChange, _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var _e = __read(react_1.default.useState(value || ''), 2), alignment = _e[0], setAlignment = _e[1];
    var handleChange = function (event, newAlignment) {
        setAlignment(newAlignment);
        onChange === null || onChange === void 0 ? void 0 : onChange(event, newAlignment);
    };
    var iconOnly = options.every(function (option) { return !option.label; });
    return (react_1.default.createElement(styles_1.StyledToggleButtonGroup, { color: "secondary", value: alignment, exclusive: true, onChange: handleChange, variant: variant, disabled: disabled, iconOnly: iconOnly }, options.map(function (option) { return (react_1.default.createElement(ToggleButton_1.default, { key: option.value, value: option.value, disabled: alignment === option.value },
        option.icon && (react_1.default.createElement(styles_1.IconWrapper, { isSelected: alignment === option.value, variant: variant }, option.icon)),
        option.label && (react_1.default.createElement(styles_1.LabelWrapper, { isSelected: alignment === option.value, variant: variant }, option.label)))); })));
}
exports.default = ColorToggleButton;
//# sourceMappingURL=index.js.map